<template>
  <div>
    <v-layout wrap row>
      <v-flex xs5>
        <v-select
          autocomplete
          label="Awards manual status"
          :items="awardsStatuses"
          v-model="manualStatus"
        />
      </v-flex>
    </v-layout>
    <v-divider/>

    <template v-if="statusesData">
      <v-layout
        v-for="(date, stepName) in statusesData"
        :key="stepName"
        wrap
        row
      >
        <v-flex xs2 d-flex align-center>
          {{stepName}}
        </v-flex>
        <v-flex xs2 d-flex align-center>
          {{date | timeStamp}}
        </v-flex>
        <v-flex>
          <v-btn @click="openSelectDateWindow(date, stepName)">Change date</v-btn>
        </v-flex>
      </v-layout>
    </template>
    <br>
    <v-layout>
      <v-flex>
        <v-btn class="green white--text" @click="update">Update</v-btn>
      </v-flex>
    </v-layout>
    <v-dialog
      persistent
      v-model="isDialogVisible"
      width="800"
    >
      <v-card>
        <v-card-text>
          <v-layout row wrap>
            <v-flex d-flex justify-space-between>
              <v-date-picker
                v-model="selectedStep.date"
                :show-current="false"
              />
              <v-spacer/>
              <v-time-picker
                v-model="selectedStep.time"
                format="24hr"
              />
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn class="green white--text" @click="setNewTimeStamp">Set</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { path, pathOr } from 'ramda'
import moment from  'moment'

// function which prepends zero to number if it's length less than 2. Example: 6 => '06'
const pad = number => number.toString().length < 2 ? `0${number}` : number

// function which returns date string by timeStamp
const getDateString = timeStamp => {
  const date = new Date(timeStamp)
  const year = date.getFullYear()
  const month = pad(date.getMonth() + 1)
  const day = pad(date.getDate())
  return `${year}-${month}-${day}`
}

// functoin which returns time string by timeStamp
const getTimeString = timeStamp => {
  const date = new Date(timeStamp)
  const hours = pad(date.getHours())
  const minutes = pad(date.getMinutes())
  return `${hours}:${minutes}`
}

export default {
  name: 'AwardsGeneralSettings',
  filters: {
    timeStamp (value) {
      const date = getDateString(value)
      const time = getTimeString(value)
      return `${date} ${time}`
    }
  },
  data () {
    return {
      statusesData: null,
      manualStatus: null,
      isDialogVisible: false,
      awardsStatuses: ['Welcome', 'PreNomination', 'Nomination', 'PreVoteOne', 'VoteOne', 'PreVoteTwo', 'VoteTwo', 'PreWining', 'Wining', 'Auto mode'],
      selectedStep: {
        name: '',
        date: '',
        time: ''
      }
    }
  },
  computed: {
    ...mapGetters(['getSettings']),
    getAwardsSettings () {
      return path(['awardsSetting'], this.getSettings)
    }
  },
  watch: {
    isDialogVisible (isVisible) {
      if (!isVisible) {
        this.selectedStep = {name: '', date: '', time: ''}
      }
    }
  },
  async mounted () {
    await this.fetchGeneralSettings()
    this.statusesData = this.timeToTimeZone(path(['statusesToDateMap'], this.getAwardsSettings), 'add', 1)
    this.manualStatus = pathOr('Auto mode', ['manualStatus'], this.getAwardsSettings)
  },
  methods: {
    ...mapActions({
      fetchGeneralSettings: 'fetchGeneralSettings',
      updateSettings: 'putAwardsGeneralSettings',
      showResultErrorMessage: 'showResultErrorMessage'
    }),
    openSelectDateWindow (stepTimeStamp, name) {
      const date = getDateString(stepTimeStamp)
      const time = getTimeString(stepTimeStamp)
      this.selectedStep = {name, date, time}
      this.isDialogVisible = true
    },
    setNewTimeStamp () {
      const timeStamp = `${this.selectedStep.date} ${this.selectedStep.time}`
      const dateString = getDateString(timeStamp)
      const timeString = getTimeString(timeStamp)
      this.statusesData = {...this.statusesData, [this.selectedStep.name]: `${dateString} ${timeString}`}
      this.isDialogVisible = false
    },
    timeToTimeZone (statusesDataObj, condition, quantity) {
      // This function transform date from utc (get from BE) to London time zone (+1)
      // If condition = 'add' and change back to utc if conditoon 'subtract'
      let resObj = {}
      for (let time in statusesDataObj) {
        const fullString = statusesDataObj[time]
        const dateMask = 'MM/DD/YYYY HH:mm:ss'
        const momentStr = condition === 'add'
          ? moment(fullString).add(quantity, 'hours').format(dateMask)
          : moment(fullString).subtract(quantity, 'hours').format(dateMask)
        resObj[time] = momentStr
      }
      return resObj
    },
    checkIfDatesAreUnique (datesList) {
      return (new Set(datesList)).size === datesList.length;
    },
    update () {
      const payload = {
        statusesToDateMap: this.timeToTimeZone(this.statusesData, 'subtract', 1),
        manualStatus: this.manualStatus === 'Auto mode' ? null : this.manualStatus
      }
      const datesList = Object.values(payload.statusesToDateMap)
      let areDatesUnique = this.checkIfDatesAreUnique(datesList)
      areDatesUnique ? this.updateSettings(payload) : this.showResultErrorMessage('Some of chosen dates are duplicated ')
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/pages/Awards/Settings/General/index.vue